import { Router } from '@angular/router';
import { MapsResult, AddressComponent, Endereco } from './interfaces';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {
  indexEdit: any;

  constructor(
    private http: HttpClient,
    private fire: AngularFireAuth,
    private fireStore: AngularFirestore,
    private confirmation: ConfirmationService,
    private router: Router
  ) {
    this.fire.auth.onAuthStateChanged(user => {
      if (user) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.lng = position.coords.longitude;
            this.lat = position.coords.latitude;
            this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.lat},${this.lng}&key=AIzaSyAbVMD_snr6tRhLlYFtoUMAyMdxOuTj5zw`)
            .subscribe((end: any) => {
              this.endereco = end.results[0].formatted_address
              this.input = true;
              console.log(end.results[0]);
            })
          });
        }
        this.fireStore.collection('users').doc(this.fire.auth.currentUser.uid).ref.get().then(dado => {
          this.enderecos = dado.data().enderecos
          console.log(this.enderecos)
        })
      } else {
        this.router.navigate([''])
      }
    })
  }

  // Controle do Mapa
  public input = false;
  public ends = false;
  public lat: number = -19.9002431;
  public lng: number = -43.897945;
  public zoom: number = 15;
  public endereco: string;
  // Controle do Mapa

  // Variáveis de usuário
  public enderecoCompleto: Endereco = {
    nome: '', cep: '', rua: '', numero: '', bairro: '',
    cidade: '', estado: '', pais: '', lat: 0, lng: 0,
    complementos: ''
  };
  public enderecos: Endereco[] = [];
  public enderecoEdit: Endereco = {
    nome: '', cep: '', rua: '', numero: '', bairro: '',
    cidade: '', estado: '', pais: '', lat: 0, lng: 0,
    complementos: ''
  };;
  // Variáveis de usuário

  // Displays
  public terminaCadastro = false;
  public edit: boolean;
  // Displays


  // On Init
  ngOnInit() {

  }
  // On Init

  // Controle de Endereço
  public registaEndereco() {
    console.log(this.fire.auth.currentUser);
    const link = 'https://maps.googleapis.com/maps/api/geocode/json?address='
    const end = '&key=AIzaSyAbVMD_snr6tRhLlYFtoUMAyMdxOuTj5zw'
    const address = this.endereco.split(' ').join('+');
    let subs = this.http.get(link + address + end).subscribe((dado: any) => {
      if (dado.results.length > 0) {
        this.getDadosEndereco(dado.results[0]).then(() => {
          console.log(this.lat, this.lng)
          console.log(this.enderecoCompleto.estado)
          if (this.enderecoCompleto.cidade == 'Belo Horizonte') {
            this.confirmation.confirm({
              header: 'Sucesso!',
              message: `Parabéns! Seu endereço está em nossa área de cobertura!`,
              acceptLabel: 'Continuar',
              rejectLabel: 'Cancelar',
              accept: () => {
                this.terminaCadastro = true;
              }
            });
          } else {
            this.confirmation.confirm({
              header: 'Aviso',
              acceptLabel: 'Sim',
              rejectLabel: 'Não',
              message: `Infelizmente seu endereço não está em nossa área de cobertura.<br>
                        Deseja ser notificado quando estivermos atendendo em sua região?`,
              accept: () => {
                this.fireStore.collection('emailMarketing').doc(this.generateId()).set({
                  email: this.fire.auth.currentUser.email,
                  endereco: dado
                })
              }
            });
          }
        });
      }
      subs.unsubscribe();
    });
  }

  public selectEndereco(endereco: Endereco) {
    this.lat = endereco.lat;
    this.lng = endereco.lng;
  }

  log(e) {
    console.log(e);
  }

  public realizaCadastro() {
    this.terminaCadastro = false;
    this.ends = false;
    this.enderecos.push(this.enderecoCompleto);
    this.fireStore.collection('users').doc(this.fire.auth.currentUser.uid)
      .set({
        enderecos: this.enderecos
      })
      .then(() => {
        this.fireStore.collection('users').doc(this.fire.auth.currentUser.uid).ref.get().then(dado => {
          this.enderecos = dado.data().enderecos
          console.log(this.enderecos)
          this.ends = true;
        })
      });
  }

  private getDadosEndereco(endereco: MapsResult) {
    return new Promise((resolve, reject) => {
      endereco.address_components.forEach((componente: AddressComponent) => {
        componente.types.forEach(tipo => {
          switch (tipo) {
            case 'street_number':
              this.enderecoCompleto.numero = componente.long_name;
              break;
            case 'route':
              this.enderecoCompleto.rua = componente.long_name;
              break;
            case 'sublocality_level_1':
              this.enderecoCompleto.bairro = componente.long_name;
              break;
            case 'administrative_area_level_2':
              this.enderecoCompleto.cidade = componente.long_name;
              break;
            case 'administrative_area_level_1':
              this.enderecoCompleto.estado = componente.long_name;
              break;
            case 'country':
              this.enderecoCompleto.pais = componente.long_name;
              break;
            case 'postal_code':
              this.enderecoCompleto.cep = componente.long_name;
          }
          this.enderecoCompleto.lat = endereco.geometry.location.lat;
          this.enderecoCompleto.lng = endereco.geometry.location.lng;
          this.lat = endereco.geometry.location.lat;
          this.lng = endereco.geometry.location.lng;
        });
      });
      console.log(this.enderecoCompleto);
      resolve(true);
    });
  }

  removeEndereco(index) {
    this.confirmation.confirm({
      message: `Tem certeza que deseja excluir esse endereço?`,
      accept: () => {
        this.enderecos.splice(index, 1);
        this.fireStore.collection('users').doc(this.fire.auth.currentUser.uid).update({
          enderecos: this.enderecos
        });
      }
    });
  }

  editaEndereco(index) {
    this.indexEdit = index;
    this.enderecoEdit = JSON.parse(JSON.stringify(this.enderecos[index]));
    this.edit = true;
  }

  confirmEditarEndereco() {
    this.edit = false;
    this.enderecos.splice(this.indexEdit, 1);
    this.enderecos.push(this.enderecoEdit);
    this.fireStore.collection('users').doc(this.fire.auth.currentUser.uid).update({
      enderecos: this.enderecos
    });
  }
  // Controle de Endereço

  generateId() {
    var randomized = Math.ceil(Math.random() * Math.pow(10, 10)).toString()
    let date = new Date().getMilliseconds()
    return randomized + date
  }
}
